import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  addedProducts: {},
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setHasAdded: (state, action) => {
      const { productId, value } = action.payload;
      state.addedProducts[productId] = value;
    },
  },
});

export const { setHasAdded } = productSlice.actions;

export default productSlice.reducer;
